import axios from "axios";
import { TaskRecordCollectionData, TaskRecordCollectionSendData } from "../types/TaskCollection";
import { TaskRecord, TaskResponse, TaskStatus } from "../types/Task"; // generic response

// TODO: after creating taskRecords
export const createTaskCollection = async (data: TaskRecordCollectionSendData) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    console.log(data)

    return {
        status: 200,
        data: {
            "id": 945,
            "name": "Server send recharge job",
            "status": 1,
            "createdDatetime": "2023-08-29T19:36:03.919655+08:00",
            "assignedDatetime": null,
            "endDatetime": "2023-08-29T19:41:28.233783+08:00",
            "taskRecords": [
                {
                    "id": 5065,
                    "taskRecord": 6280,
                    "sequence": 1,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5066,
                    "taskRecord": 6281,
                    "sequence": 2,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5067,
                    "taskRecord": 6282,
                    "sequence": 3,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5068,
                    "taskRecord": 6283,
                    "sequence": 4,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5069,
                    "taskRecord": 6284,
                    "sequence": 5,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5070,
                    "taskRecord": 6285,
                    "sequence": 6,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5071,
                    "taskRecord": 6286,
                    "sequence": 7,
                    "taskRecordCollection": 945
                }
            ],
            "parentTaskRecord": null,
            "progressIndex": 0,
            "sourceLocation": 60,
            "targetLocation": 53,
            "taskCollectionType": 1,
            "compartmentIndex": 0,
            "waitTime": null
        }
    } as TaskResponse;
}

export const getLocationTasks = async (location_id: number) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return await axios.post("/api/taskRecordCollections/getLocationRecord/?id=" + String(location_id))
            .then(response => response.data) as TaskRecordCollectionData
}

export const latestLocationTaskCollections = async (locationId: number) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {
        "id": 945,
        "name": "Server send recharge job",
        "status": 1,
        "createdDatetime": "2023-08-29T19:36:03.919655+08:00",
        "assignedDatetime": null,
        "endDatetime": "2023-08-29T19:41:28.233783+08:00",
        "taskRecords": [
            {
                "id": 5065,
                "taskRecord": 6280,
                "sequence": 1,
                "taskRecordCollection": 945
            },
            {
                "id": 5066,
                "taskRecord": 6281,
                "sequence": 2,
                "taskRecordCollection": 945
            },
            {
                "id": 5067,
                "taskRecord": 6282,
                "sequence": 3,
                "taskRecordCollection": 945
            },
            {
                "id": 5068,
                "taskRecord": 6283,
                "sequence": 4,
                "taskRecordCollection": 945
            },
            {
                "id": 5069,
                "taskRecord": 6284,
                "sequence": 5,
                "taskRecordCollection": 945
            },
            {
                "id": 5070,
                "taskRecord": 6285,
                "sequence": 6,
                "taskRecordCollection": 945
            },
            {
                "id": 5071,
                "taskRecord": 6286,
                "sequence": 7,
                "taskRecordCollection": 945
            }
        ],
        "parentTaskRecord": null,
        "progressIndex": 0,
        "sourceLocation": 60,
        "targetLocation": 53,
        "taskCollectionType": 1,
        "compartmentIndex": 0,
        "waitTime": null
    } as unknown as TaskRecordCollectionData
}

export const globalLatestLocationTaskCollections = async () => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {
        "id": 945,
        "name": "Server send recharge job",
        "status": 1,
        "createdDatetime": "2023-08-29T19:36:03.919655+08:00",
        "assignedDatetime": null,
        "endDatetime": "2023-08-29T19:41:28.233783+08:00",
        "taskRecords": [
            {
                "id": 5065,
                "taskRecord": 6280,
                "sequence": 1,
                "taskRecordCollection": 945
            },
            {
                "id": 5066,
                "taskRecord": 6281,
                "sequence": 2,
                "taskRecordCollection": 945
            },
            {
                "id": 5067,
                "taskRecord": 6282,
                "sequence": 3,
                "taskRecordCollection": 945
            },
            {
                "id": 5068,
                "taskRecord": 6283,
                "sequence": 4,
                "taskRecordCollection": 945
            },
            {
                "id": 5069,
                "taskRecord": 6284,
                "sequence": 5,
                "taskRecordCollection": 945
            },
            {
                "id": 5070,
                "taskRecord": 6285,
                "sequence": 6,
                "taskRecordCollection": 945
            },
            {
                "id": 5071,
                "taskRecord": 6286,
                "sequence": 7,
                "taskRecordCollection": 945
            }
        ],
        "parentTaskRecord": null,
        "progressIndex": 0,
        "sourceLocation": 60,
        "targetLocation": 53,
        "taskCollectionType": 1,
        "compartmentIndex": 0,
        "waitTime": null
    } as unknown as TaskRecordCollectionData
}

export const receipientOfTaskCollection = async (locationId: number) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {
        "id": 945,
        "name": "Server send recharge job",
        "status": 1,
        "createdDatetime": "2023-08-29T19:36:03.919655+08:00",
        "assignedDatetime": null,
        "endDatetime": "2023-08-29T19:41:28.233783+08:00",
        "taskRecords": [
            {
                "id": 5065,
                "taskRecord": 6280,
                "sequence": 1,
                "taskRecordCollection": 945
            },
            {
                "id": 5066,
                "taskRecord": 6281,
                "sequence": 2,
                "taskRecordCollection": 945
            },
            {
                "id": 5067,
                "taskRecord": 6282,
                "sequence": 3,
                "taskRecordCollection": 945
            },
            {
                "id": 5068,
                "taskRecord": 6283,
                "sequence": 4,
                "taskRecordCollection": 945
            },
            {
                "id": 5069,
                "taskRecord": 6284,
                "sequence": 5,
                "taskRecordCollection": 945
            },
            {
                "id": 5070,
                "taskRecord": 6285,
                "sequence": 6,
                "taskRecordCollection": 945
            },
            {
                "id": 5071,
                "taskRecord": 6286,
                "sequence": 7,
                "taskRecordCollection": 945
            }
        ],
        "parentTaskRecord": null,
        "progressIndex": 0,
        "sourceLocation": 60,
        "targetLocation": 53,
        "taskCollectionType": 1,
        "compartmentIndex": 0,
        "waitTime": null
    } as unknown as TaskRecordCollectionData
}

export const cancelTaskCollections = async (updatedValue: TaskRecordCollectionData) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return await axios.put("/api/taskRecordCollections/" + updatedValue.id +"/", {
        ...updatedValue,
        status: TaskStatus.REQUEST_CANCELLED
    })
        .then(response => response.data) as TaskRecordCollectionData
}

export const listTaskCollections = async () => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {
        status: 200,
        data: [
            {
                "id": 945,
                "name": "Server send recharge job",
                "status": 1,
                "createdDatetime": "2023-08-29T19:36:03.919655+08:00",
                "assignedDatetime": null,
                "endDatetime": "2023-08-29T19:41:28.233783+08:00",
                "taskRecords": [
                    {
                        "id": 5065,
                        "taskRecord": 6280,
                        "sequence": 1,
                        "taskRecordCollection": 945
                    },
                    {
                        "id": 5066,
                        "taskRecord": 6281,
                        "sequence": 2,
                        "taskRecordCollection": 945
                    },
                    {
                        "id": 5067,
                        "taskRecord": 6282,
                        "sequence": 3,
                        "taskRecordCollection": 945
                    },
                    {
                        "id": 5068,
                        "taskRecord": 6283,
                        "sequence": 4,
                        "taskRecordCollection": 945
                    },
                    {
                        "id": 5069,
                        "taskRecord": 6284,
                        "sequence": 5,
                        "taskRecordCollection": 945
                    },
                    {
                        "id": 5070,
                        "taskRecord": 6285,
                        "sequence": 6,
                        "taskRecordCollection": 945
                    },
                    {
                        "id": 5071,
                        "taskRecord": 6286,
                        "sequence": 7,
                        "taskRecordCollection": 945
                    }
                ],
                "parentTaskRecord": null,
                "progressIndex": 0,
                "sourceLocation": 60,
                "targetLocation": 53,
                "taskCollectionType": 1,
                "compartmentIndex": 0,
                "waitTime": null
            },
            {
                "id": 944,
                "name": "New Task at L1Charge",
                "status": 1,
                "createdDatetime": "2023-08-29T19:29:41.676000+08:00",
                "assignedDatetime": null,
                "endDatetime": "2023-08-29T19:36:03.155032+08:00",
                "taskRecords": [
                    {
                        "id": 5058,
                        "taskRecord": 6273,
                        "sequence": 1,
                        "taskRecordCollection": 944
                    },
                    {
                        "id": 5059,
                        "taskRecord": 6274,
                        "sequence": 2,
                        "taskRecordCollection": 944
                    },
                    {
                        "id": 5060,
                        "taskRecord": 6275,
                        "sequence": 3,
                        "taskRecordCollection": 944
                    },
                    {
                        "id": 5061,
                        "taskRecord": 6276,
                        "sequence": 4,
                        "taskRecordCollection": 944
                    },
                    {
                        "id": 5062,
                        "taskRecord": 6277,
                        "sequence": 5,
                        "taskRecordCollection": 944
                    },
                    {
                        "id": 5063,
                        "taskRecord": 6278,
                        "sequence": 6,
                        "taskRecordCollection": 944
                    },
                    {
                        "id": 5064,
                        "taskRecord": 6279,
                        "sequence": 7,
                        "taskRecordCollection": 944
                    }
                ],
                "parentTaskRecord": null,
                "progressIndex": 4,
                "sourceLocation": 53,
                "targetLocation": 60,
                "taskCollectionType": 0,
                "compartmentIndex": 3,
                "waitTime": null
            },
            {
                "id": 943,
                "name": "Server send recharge job",
                "status": 1,
                "createdDatetime": "2023-08-29T17:21:20.945408+08:00",
                "assignedDatetime": null,
                "endDatetime": "2023-08-29T17:29:13.534290+08:00",
                "taskRecords": [
                    {
                        "id": 5051,
                        "taskRecord": 6266,
                        "sequence": 1,
                        "taskRecordCollection": 943
                    },
                    {
                        "id": 5052,
                        "taskRecord": 6267,
                        "sequence": 2,
                        "taskRecordCollection": 943
                    },
                    {
                        "id": 5053,
                        "taskRecord": 6268,
                        "sequence": 3,
                        "taskRecordCollection": 943
                    },
                    {
                        "id": 5054,
                        "taskRecord": 6269,
                        "sequence": 4,
                        "taskRecordCollection": 943
                    },
                    {
                        "id": 5055,
                        "taskRecord": 6270,
                        "sequence": 5,
                        "taskRecordCollection": 943
                    },
                    {
                        "id": 5056,
                        "taskRecord": 6271,
                        "sequence": 6,
                        "taskRecordCollection": 943
                    },
                    {
                        "id": 5057,
                        "taskRecord": 6272,
                        "sequence": 7,
                        "taskRecordCollection": 943
                    }
                ],
                "parentTaskRecord": null,
                "progressIndex": 0,
                "sourceLocation": 60,
                "targetLocation": 53,
                "taskCollectionType": 1,
                "compartmentIndex": 0,
                "waitTime": null
            },
            {
                "id": 942,
                "name": "New Task at L1Charge",
                "status": 1,
                "createdDatetime": "2023-08-29T17:14:19.364000+08:00",
                "assignedDatetime": null,
                "endDatetime": "2023-08-29T17:21:20.017298+08:00",
                "taskRecords": [
                    {
                        "id": 5044,
                        "taskRecord": 6259,
                        "sequence": 1,
                        "taskRecordCollection": 942
                    },
                    {
                        "id": 5045,
                        "taskRecord": 6260,
                        "sequence": 2,
                        "taskRecordCollection": 942
                    },
                    {
                        "id": 5046,
                        "taskRecord": 6261,
                        "sequence": 3,
                        "taskRecordCollection": 942
                    },
                    {
                        "id": 5047,
                        "taskRecord": 6262,
                        "sequence": 4,
                        "taskRecordCollection": 942
                    },
                    {
                        "id": 5048,
                        "taskRecord": 6263,
                        "sequence": 5,
                        "taskRecordCollection": 942
                    },
                    {
                        "id": 5049,
                        "taskRecord": 6264,
                        "sequence": 6,
                        "taskRecordCollection": 942
                    },
                    {
                        "id": 5050,
                        "taskRecord": 6265,
                        "sequence": 7,
                        "taskRecordCollection": 942
                    }
                ],
                "parentTaskRecord": null,
                "progressIndex": 4,
                "sourceLocation": 53,
                "targetLocation": 60,
                "taskCollectionType": 0,
                "compartmentIndex": 3,
                "waitTime": null
            },
            {
                "id": 941,
                "name": "Server send recharge job",
                "status": 1,
                "createdDatetime": "2023-08-29T17:08:40.460176+08:00",
                "assignedDatetime": null,
                "endDatetime": "2023-08-29T17:14:10.924207+08:00",
                "taskRecords": [
                    {
                        "id": 5037,
                        "taskRecord": 6252,
                        "sequence": 1,
                        "taskRecordCollection": 941
                    },
                    {
                        "id": 5038,
                        "taskRecord": 6253,
                        "sequence": 2,
                        "taskRecordCollection": 941
                    },
                    {
                        "id": 5039,
                        "taskRecord": 6254,
                        "sequence": 3,
                        "taskRecordCollection": 941
                    },
                    {
                        "id": 5040,
                        "taskRecord": 6255,
                        "sequence": 4,
                        "taskRecordCollection": 941
                    },
                    {
                        "id": 5041,
                        "taskRecord": 6256,
                        "sequence": 5,
                        "taskRecordCollection": 941
                    },
                    {
                        "id": 5042,
                        "taskRecord": 6257,
                        "sequence": 6,
                        "taskRecordCollection": 941
                    },
                    {
                        "id": 5043,
                        "taskRecord": 6258,
                        "sequence": 7,
                        "taskRecordCollection": 941
                    }
                ],
                "parentTaskRecord": null,
                "progressIndex": 0,
                "sourceLocation": 60,
                "targetLocation": 53,
                "taskCollectionType": 1,
                "compartmentIndex": 0,
                "waitTime": null
            },
            {
                "id": 940,
                "name": "New Task at L1Charge",
                "status": 1,
                "createdDatetime": "2023-08-29T17:02:39.300000+08:00",
                "assignedDatetime": null,
                "endDatetime": "2023-08-29T17:08:39.586628+08:00",
                "taskRecords": [
                    {
                        "id": 5030,
                        "taskRecord": 6245,
                        "sequence": 1,
                        "taskRecordCollection": 940
                    },
                    {
                        "id": 5031,
                        "taskRecord": 6246,
                        "sequence": 2,
                        "taskRecordCollection": 940
                    },
                    {
                        "id": 5032,
                        "taskRecord": 6247,
                        "sequence": 3,
                        "taskRecordCollection": 940
                    },
                    {
                        "id": 5033,
                        "taskRecord": 6248,
                        "sequence": 4,
                        "taskRecordCollection": 940
                    },
                    {
                        "id": 5034,
                        "taskRecord": 6249,
                        "sequence": 5,
                        "taskRecordCollection": 940
                    },
                    {
                        "id": 5035,
                        "taskRecord": 6250,
                        "sequence": 6,
                        "taskRecordCollection": 940
                    },
                    {
                        "id": 5036,
                        "taskRecord": 6251,
                        "sequence": 7,
                        "taskRecordCollection": 940
                    }
                ],
                "parentTaskRecord": null,
                "progressIndex": 4,
                "sourceLocation": 53,
                "targetLocation": 60,
                "taskCollectionType": 0,
                "compartmentIndex": 3,
                "waitTime": null
            },
            {
                "id": 939,
                "name": "Server send recharge job",
                "status": 1,
                "createdDatetime": "2023-08-29T09:54:55.916635+08:00",
                "assignedDatetime": null,
                "endDatetime": "2023-08-29T10:00:18.534901+08:00",
                "taskRecords": [
                    {
                        "id": 5023,
                        "taskRecord": 6238,
                        "sequence": 1,
                        "taskRecordCollection": 939
                    },
                    {
                        "id": 5024,
                        "taskRecord": 6239,
                        "sequence": 2,
                        "taskRecordCollection": 939
                    },
                    {
                        "id": 5025,
                        "taskRecord": 6240,
                        "sequence": 3,
                        "taskRecordCollection": 939
                    },
                    {
                        "id": 5026,
                        "taskRecord": 6241,
                        "sequence": 4,
                        "taskRecordCollection": 939
                    },
                    {
                        "id": 5027,
                        "taskRecord": 6242,
                        "sequence": 5,
                        "taskRecordCollection": 939
                    },
                    {
                        "id": 5028,
                        "taskRecord": 6243,
                        "sequence": 6,
                        "taskRecordCollection": 939
                    },
                    {
                        "id": 5029,
                        "taskRecord": 6244,
                        "sequence": 7,
                        "taskRecordCollection": 939
                    }
                ],
                "parentTaskRecord": null,
                "progressIndex": 0,
                "sourceLocation": 60,
                "targetLocation": 53,
                "taskCollectionType": 1,
                "compartmentIndex": 0,
                "waitTime": null
            }
        ]
    } as TaskResponse   
}


export const getDetailedTaskRecordCollection = async (id: number) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {
        status: 200,
        data: {
            "id": 945,
            "name": "Server send recharge job",
            "status": 1,
            "createdDatetime": "2023-08-29T19:36:03.919655+08:00",
            "assignedDatetime": null,
            "endDatetime": "2023-08-29T19:41:28.233783+08:00",
            "taskRecords": [
                {
                    "id": 6280,
                    "task_id": 6432,
                    "robot": 1,
                    "createdDatetime": "2023-08-29T19:36:15.565975+08:00",
                    "assignedDatetime": "2023-08-29T19:36:18.154019+08:00",
                    "completedDatetime": "2023-08-29T19:36:50.186410+08:00",
                    "status": 1,
                    "path": [
                        {
                            "location": {
                                "id": 58,
                                "displayName": "door_3_L14",
                                "image": "/tasks_location/default_eplSHE8.png",
                                "map": 10,
                                "name": "door_3_L14",
                                "locationType": 1
                            },
                            "taskRecord_id": 6280,
                            "startTime": "2023-08-29T19:36:15.655563+08:00",
                            "completedTime": null,
                            "status": 1
                        }
                    ],
                    "taskType": 0,
                    "startFrom": {
                        "id": 58,
                        "displayName": "door_3_L14",
                        "image": "/tasks_location/default_eplSHE8.png",
                        "map": 10,
                        "name": "door_3_L14",
                        "locationType": 1
                    },
                    "events": []
                },
                {
                    "id": 6281,
                    "task_id": 6433,
                    "robot": 1,
                    "createdDatetime": "2023-08-29T19:36:55.721499+08:00",
                    "assignedDatetime": "2023-08-29T19:36:57.415416+08:00",
                    "completedDatetime": "2023-08-29T19:37:33.658729+08:00",
                    "status": 1,
                    "path": [
                        {
                            "location": {
                                "id": 63,
                                "displayName": "j1_L14",
                                "image": "/tasks_location/face.gif",
                                "map": 10,
                                "name": "j1_L14",
                                "locationType": 1
                            },
                            "taskRecord_id": 6281,
                            "startTime": "2023-08-29T19:36:55.745555+08:00",
                            "completedTime": null,
                            "status": 1
                        }
                    ],
                    "taskType": 0,
                    "startFrom": {
                        "id": 63,
                        "displayName": "j1_L14",
                        "image": "/tasks_location/face.gif",
                        "map": 10,
                        "name": "j1_L14",
                        "locationType": 1
                    },
                    "events": []
                },
                {
                    "id": 6282,
                    "task_id": 6434,
                    "robot": 1,
                    "createdDatetime": "2023-08-29T19:37:40.542407+08:00",
                    "assignedDatetime": "2023-08-29T19:37:42.069948+08:00",
                    "completedDatetime": "2023-08-29T19:38:24.591344+08:00",
                    "status": 1,
                    "path": [
                        {
                            "location": {
                                "id": 55,
                                "displayName": "lift_point_L14",
                                "image": "/tasks_location/default_NJrNS1W.png",
                                "map": 10,
                                "name": "lift_point_L14",
                                "locationType": 1
                            },
                            "taskRecord_id": 6282,
                            "startTime": "2023-08-29T19:37:40.573609+08:00",
                            "completedTime": null,
                            "status": 1
                        }
                    ],
                    "taskType": 0,
                    "startFrom": {
                        "id": 55,
                        "displayName": "lift_point_L14",
                        "image": "/tasks_location/default_NJrNS1W.png",
                        "map": 10,
                        "name": "lift_point_L14",
                        "locationType": 1
                    },
                    "events": []
                },
                {
                    "id": 6283,
                    "task_id": 6435,
                    "robot": 1,
                    "createdDatetime": "2023-08-29T19:39:14.749405+08:00",
                    "assignedDatetime": "2023-08-29T19:39:17.095965+08:00",
                    "completedDatetime": "2023-08-29T19:39:32.534311+08:00",
                    "status": 1,
                    "path": [
                        {
                            "location": {
                                "id": 54,
                                "displayName": "inside_lift_point_L14",
                                "image": "/tasks_location/default_fF9gpSl.png",
                                "map": 10,
                                "name": "inside_lift_point_L14",
                                "locationType": 3
                            },
                            "taskRecord_id": 6283,
                            "startTime": "2023-08-29T19:39:14.856317+08:00",
                            "completedTime": null,
                            "status": 1
                        }
                    ],
                    "taskType": 0,
                    "startFrom": {
                        "id": 54,
                        "displayName": "inside_lift_point_L14",
                        "image": "/tasks_location/default_fF9gpSl.png",
                        "map": 10,
                        "name": "inside_lift_point_L14",
                        "locationType": 3
                    },
                    "events": []
                },
                {
                    "id": 6284,
                    "task_id": 6436,
                    "robot": 1,
                    "createdDatetime": "2023-08-29T19:40:24.980854+08:00",
                    "assignedDatetime": "2023-08-29T19:40:25.035288+08:00",
                    "completedDatetime": "2023-08-29T19:40:25.378820+08:00",
                    "status": 1,
                    "path": [
                        {
                            "location": {
                                "id": 52,
                                "displayName": "inside_lift_L1",
                                "image": "/tasks_location/default_2sgHTMI.png",
                                "map": 9,
                                "name": "inside_lift_L1",
                                "locationType": 3
                            },
                            "taskRecord_id": 6284,
                            "startTime": "2023-08-29T19:40:25.012359+08:00",
                            "completedTime": null,
                            "status": 1
                        }
                    ],
                    "taskType": 0,
                    "startFrom": {
                        "id": 52,
                        "displayName": "inside_lift_L1",
                        "image": "/tasks_location/default_2sgHTMI.png",
                        "map": 9,
                        "name": "inside_lift_L1",
                        "locationType": 3
                    },
                    "events": []
                },
                {
                    "id": 6285,
                    "task_id": 6437,
                    "robot": 1,
                    "createdDatetime": "2023-08-29T19:40:28.521025+08:00",
                    "assignedDatetime": "2023-08-29T19:40:30.458831+08:00",
                    "completedDatetime": "2023-08-29T19:40:39.704366+08:00",
                    "status": 1,
                    "path": [
                        {
                            "location": {
                                "id": 51,
                                "displayName": "lift_point_L1b",
                                "image": "/tasks_location/default_qWerK9m.png",
                                "map": 9,
                                "name": "lift_point_L1b",
                                "locationType": 1
                            },
                            "taskRecord_id": 6285,
                            "startTime": "2023-08-29T19:40:28.528494+08:00",
                            "completedTime": null,
                            "status": 1
                        }
                    ],
                    "taskType": 0,
                    "startFrom": {
                        "id": 51,
                        "displayName": "lift_point_L1b",
                        "image": "/tasks_location/default_qWerK9m.png",
                        "map": 9,
                        "name": "lift_point_L1b",
                        "locationType": 1
                    },
                    "events": []
                },
                {
                    "id": 6286,
                    "task_id": 6438,
                    "robot": 1,
                    "createdDatetime": "2023-08-29T19:40:47.169118+08:00",
                    "assignedDatetime": "2023-08-29T19:40:49.225402+08:00",
                    "completedDatetime": "2023-08-29T19:41:28.874217+08:00",
                    "status": 1,
                    "path": [
                        {
                            "location": {
                                "id": 53,
                                "displayName": "L1Charge",
                                "image": "/tasks_location/default_LkyDrdu.png",
                                "map": 9,
                                "name": "L1Charge",
                                "locationType": 3
                            },
                            "taskRecord_id": 6286,
                            "startTime": "2023-08-29T19:40:47.298390+08:00",
                            "completedTime": null,
                            "status": 1
                        }
                    ],
                    "taskType": 0,
                    "startFrom": {
                        "id": 53,
                        "displayName": "L1Charge",
                        "image": "/tasks_location/default_LkyDrdu.png",
                        "map": 9,
                        "name": "L1Charge",
                        "locationType": 3
                    },
                    "events": []
                }
            ],
            "parentTaskRecord": null,
            "progressIndex": 0,
            "sourceLocation": 60,
            "targetLocation": 53,
            "taskCollectionType": 1,
            "compartmentIndex": 0,
            "waitTime": null
        }
    } as TaskResponse
}

export const updateTaskRecordCollection = async (trc: TaskRecordCollectionData) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {
        status: 200,
        data: {
            "id": 945,
            "name": "Server send recharge job",
            "status": 1,
            "createdDatetime": "2023-08-29T19:36:03.919655+08:00",
            "assignedDatetime": null,
            "endDatetime": "2023-08-29T19:41:28.233783+08:00",
            "taskRecords": [
                {
                    "id": 5065,
                    "taskRecord": 6280,
                    "sequence": 1,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5066,
                    "taskRecord": 6281,
                    "sequence": 2,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5067,
                    "taskRecord": 6282,
                    "sequence": 3,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5068,
                    "taskRecord": 6283,
                    "sequence": 4,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5069,
                    "taskRecord": 6284,
                    "sequence": 5,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5070,
                    "taskRecord": 6285,
                    "sequence": 6,
                    "taskRecordCollection": 945
                },
                {
                    "id": 5071,
                    "taskRecord": 6286,
                    "sequence": 7,
                    "taskRecordCollection": 945
                }
            ],
            "parentTaskRecord": null,
            "progressIndex": 0,
            "sourceLocation": 60,
            "targetLocation": 53,
            "taskCollectionType": 1,
            "compartmentIndex": 0,
            "waitTime": null
        }
    }
}